import React, { useState } from 'react';
import CreatePassword from 'pages/auth/CreatePassword';
import PasswordVerification from 'pages/auth/PasswordVerification';
import AuthWrapper from './AuthWrapper';

const ResetPassword = () => {
  const [isPasswordComp, setIsPasswordComp] = useState(null);

  return (
    <AuthWrapper>
      {isPasswordComp ? (
        <CreatePassword
          handleChangeToPassword={setIsPasswordComp}
        />
      ) : (
        <PasswordVerification
          // isPasswordComp={isPasswordComp}
          handleChangeToPassword={setIsPasswordComp}
          // getOtp={setOtp}
        />
      )}
    </AuthWrapper>
  );
};

export default ResetPassword;
